import { SearchFilter } from '../common/search-filter';
import { CompanyUniverseSearch } from '../enums/company-universe-search';

export class CompanySearchCriteria extends SearchFilter {
	public Name: string;
	public VatNumber: string;
	public CountryCode: string;
	public OnlyFinanciers: boolean;
	public CompanyUniverseSearch: CompanyUniverseSearch;
}
